import { getContrastRatio } from "@mui/material";

export const decodeColor = (color, theme, bgcolor = null) => {
    if (!Boolean(color) && bgcolor === null) return undefined;
    if (!Boolean(color) && bgcolor === undefined) return theme.palette.text.primary;
    if (!Boolean(color)) {
        if (getContrastRatio(bgcolor, "#FFFFFF") > 4.5) return theme.palette.whiteSmoke.main;
        return theme.palette.text.primary;
    }
    if (color.startsWith("#")) return color;
    if (color.indexOf(".") < 0) return theme.palette[color].main;
    const parts = color.split(".");
    return theme.palette[parts[0]][parts[1]];
}
